export enum ScheduledCallOwnership {
  Queue = 1,
  LastAgent = 2,
}
